/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/studiobarnhus/"

const studiobarnhus: CommunityData = {
  code: "studiobarnhus",
  inviteCode: "studiobarnhus",
  name: "Studio Barnhus",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/stb-080`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#000000",
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[160px] h-[150px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[150px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ffffff",
      asideBg: "#ffffff",
      asideStyles: "",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      mainFont: "font-['NeueHaasGroteskDisplayPro55Roman']",
      primaryButton:
        "bg-[#000000] border border-[#000000] px-6 py-4 !text-[#ffffff] font-['NeueHaasGroteskDisplayPro65Medium'] !text-[20px] text-left leading-[120%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#d5d5d5]",
      item: "font-['NeueHaasGroteskDisplayPro65Medium'] text-[16px] text-[#000000] uppercase text-left leading-[120%] bg-[#ffffff] gap-x-[10px] text-opacity-50 text-center border-b border-[#d5d5d5] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ffffff] !pb-8",
      titles:
        "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[32px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#D5D5D5]",
        sectionTitle:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[32px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-[326px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[24px] text-left leading-[110%]",
          subtitle:
            "text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#D5D5D5]",
        sectionTitle:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[32px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[18px] text-left leading-[110%]",
          subtitle:
            "text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[120%] mt-2",
          location:
            "text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] text-left leading-[120%] mt-1",
          date: "text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%]",
        text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[32px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#D5D5D5]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[32px] text-left leading-[110%]",
        subtitle:
          "text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[160%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#000000] px-6 py-4 !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['NeueHaasGroteskDisplayPro65Medium'] !text-[20px] text-left leading-[120%]",
        questions: "text-[14px] text-left leading-[120%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#D5D5D5] border-t",
        header:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%]",
        text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#D5D5D5] border-t",
        header:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%]",
        text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#D5D5D5] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%]",
        text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[32px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8",
        outerContainer: "flex flex-col !bg-[#ffffff]",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff] border-b border-[#D5D5D5] py-4 mb-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[18px] text-left leading-[110%] mb-1",
          description:
            "text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro65Medium'] text-[18px] text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[120%]",
          status:
            "text-[#6d6d6d] font-['NeueHaasGroteskDisplayPro65Medium'] text-[18px] text-left leading-[110%]",
          counterContainer: "bg-[#ffffff] border border-[#000000] px-4 py-3 gap-x-4 !w-fit !h-10",
          button:
            "bg-[#ffffff] border border-[#000000] px-4 py-3 text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[120%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default studiobarnhus
